import type { ICityRaw, IRegionCity } from '@/entities/location/model/types/location';

export const modifyCities = (cities: ICityRaw[]): IRegionCity[] =>
  cities.map(({ id, name, slug }) => ({ id, name, slug }));
